import StatusTag from './StatusTag';
import AdTag from './AdTag';

export { StatusTag, AdTag };
